
import nakamaUtilInstance, { session } from '../utils/nakama';
// import { useQuery } from '@tanstack/react-query';
// import { REACT_QUERY_FN_KEYS } from './reactQuery';

// TODO: turn these into env variables
// Import the functions you need from the SDKs you need
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { showSuccessToast, showErrorToast } from '../components/toasts';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCYyC50CsREsRIdf9B87nRJrdVNW0rJJmg",
  authDomain: "zoombies-world.firebaseapp.com",
  projectId: "zoombies-world",
  storageBucket: "zoombies-world.appspot.com",
  messagingSenderId: "811246322638",
  appId: "1:811246322638:web:9f1344b1912f16d1f8a19f",
  measurementId: "G-G4X30VR3XD"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);


export const messaging = async () => {
  const supported = await isSupported();
  if (supported) {
    return getMessaging(firebaseApp);
  }
};

export const messagingKey =
  'BPCXaveeyc6eZE4bU-8Z2lKArTcmMlwCn_Vz85bT5qIFYQvLEnwTDUluS4itN33ZdMDG4RBDZQq1n9-gwXdYKd0';

const firebaseMessageHandler = (payload) => {
  //call function to show toast in lobby
  //BonezToast.showErrorToast('notification', payload.notification.title, payload.notification.body);
  showSuccessToast('bg-notification', payload.notification.body);
};

export const getDeviceToken = async (serviceWorker) => {
  const message = await messaging();
  const token = await getToken(message, {
    vapidKey: messagingKey,
    serviceWorkerRegistration: serviceWorker,
  });
  return token;
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await saveDeviceTokenToNakama();
      showSuccessToast('notification-permission-granted', 'Notification permission granted');

      new Notification('Notification permission granted', {
        body: 'Background Bonez notifications are now enabled, and will appear like this',
        icon: 'https://zoombies.world/images/bonez/bonez_logo_192x192.png',
      });
    } else {
      showErrorToast(
        'notification-permission-denied',
        'Please re-enable notifications in address bar to receive updates'
      );
    }
  } catch (e) {
    console.error(e);
  }
};

export const registerServiceWorkerListener = async () => {
  if (!('PushManager' in window)) {
    console.log('PushManager not in window');
    // Push isn't supported on this browser, disable or hide UI.
    return;
  }
  if ('serviceWorker' in navigator) {
    // const serviceWorker = await navigator.serviceWorker.register(
    //   `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
    // );
    // const token = await getDeviceToken(serviceWorker);
    const messaging = getMessaging();

    onMessage(messaging, (payload) => {
      firebaseMessageHandler(payload);
    });

  }
}

export const saveDeviceTokenToNakama = async () => {
  try {
    const message = await messaging();
    // const session = await nakamaUtilInstance.getNakamaUserSession();
    if (session) {
      if ('serviceWorker' in navigator) {
        // const serviceWorker = await navigator.serviceWorker.register('./firebase-messaging-sw.js');
        // console.log(process.env.PUBLIC_URL);
        const serviceWorker = await navigator.serviceWorker.register(
          `/bonez/firebase-messaging-sw.js`
        );

        const token = await getDeviceToken(serviceWorker);
        if (token) {
          const res = await nakamaUtilInstance.client.rpc(session, 'checkAndWriteUserNotifications', {
            token,
          });

          if (res?.payload?.code === 'ok') {
            // console.log('Device token saved to Nakama');
            onMessage(message, (payload) => {
              firebaseMessageHandler(payload);
            });

            return token;
          }
        } else {
          await requestNotificationPermission(session);
        }
      }
    }
  } catch (error) {
    console.error('Failed to save device token to Nakama: ', error);
    return null;
  }
};

// export const saveFCMTokenQuery = () =>
//   useQuery({
//     queryKey: ['saveFCMToken'],
//     queryFn: () => saveDeviceTokenToNakama(),
//     refetchOnWindowFocus: false,
//   });
